import { devLog } from '../utils';
import {
  UPDATE_FEED_ENTRY_PROPS,
  REGISTER_FEED_ENTRY_UI_CHANGE,
  UPDATE_RITMO_REGISTERED_IMPRESSIONS,
  UPDATE_NUM_ENTRIES,
  UPDATE_IS_RESTORING_SCROLL_POSITION
} from './feed-actions';

export function reducer(state, action) {
  switch (action.type) {
    case REGISTER_FEED_ENTRY_UI_CHANGE: {
      devLog(`[feed-reducer] action ${action.type}`);
      return {
        ...state,
        uiUpdateToggle: !state.uiUpdateToggle
      };
    }
    case UPDATE_FEED_ENTRY_PROPS: {
      const { entityId, entryProps } = action.payload;
      return {
        ...state,
        props: {
          ...state.props,
          [entityId]: entryProps
        }
      };
    }
    case UPDATE_RITMO_REGISTERED_IMPRESSIONS: {
      const { key } = action.payload;

      const list = state.ritmoRegisteredImpressions;
      if (state.ritmoRegisteredImpressions.indexOf(key) === -1) {
        list.push(key);
      }

      return {
        ...state,
        ritmoRegisteredImpressions: list
      };
    }
    case UPDATE_NUM_ENTRIES: {
      const { numEntries } = action.payload;
      return {
        ...state,
        numEntries
      };
    }
    case UPDATE_IS_RESTORING_SCROLL_POSITION: {
      const { status } = action.payload;
      return {
        ...state,
        isUpdatingScrollPosition: status
      };
    }
    default:
      throw new Error(`${action.type} - not recognized`);
  }
}

export default { reducer };
